var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Descargar reporte")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "fecha",
                      locale: "es",
                      "only-date": "",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.fecha,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fecha", $$v)
                      },
                      expression: "form.fecha"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Fecha:")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field select2 select2-field--stretch" },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        filterable: false,
                        label: "descripcion",
                        placeholder: "Seleccione...",
                        options: _vm.bodegas,
                        id: "bodegas"
                      },
                      on: { input: _vm.inputBodega },
                      model: {
                        value: _vm.selectedBodega,
                        callback: function($$v) {
                          _vm.selectedBodega = $$v
                        },
                        expression: "selectedBodega"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodegas" } }, [
                      _vm._v("Sucursal")
                    ])
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte general de cartera")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a1e0cb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a1e0cb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteGeneralCartera.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8a1e0cb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteGeneralCartera.vue
// module chunks = 0